import { i18n } from '@/shared/i18n';

// eslint-disable-next-line i18next/no-literal-string -- switch discriminators, also matched by literal to route each item to its own API field; getBiographyItemLabel carries the copy
export const BIOGRAPHY_ITEM_LABELS = ['Career', 'Lifestyle', 'Social Media', 'Values'] as const;

export type BiographyItemLabel = (typeof BIOGRAPHY_ITEM_LABELS)[number];

const LABEL_KEY_BY_ITEM = {
  Career: 'audiences:audiences.biographyItems.career',
  Lifestyle: 'audiences:audiences.biographyItems.lifestyle',
  'Social Media': 'audiences:audiences.biographyItems.socialMedia',
  Values: 'audiences:audiences.biographyItems.values',
} as const;

// A Map keyed by `string`: the form stores the item as a bare `z.string()`, so the
// lookup has to accept any value while keeping the key union `i18n.t` type-checks against.
const LABEL_KEYS = new Map<string, (typeof LABEL_KEY_BY_ITEM)[BiographyItemLabel]>(
  Object.entries(LABEL_KEY_BY_ITEM),
);

export function getBiographyItemLabel(item: string): string {
  const key = LABEL_KEYS.get(item);
  return key ? i18n.t(key) : item;
}
